import { render, staticRenderFns } from "./OnlineServiceDetailBox.vue?vue&type=template&id=a18bbaac"
import script from "./OnlineServiceDetailBox.vue?vue&type=script&lang=js"
export * from "./OnlineServiceDetailBox.vue?vue&type=script&lang=js"
import style0 from "./OnlineServiceDetailBox.vue?vue&type=style&index=0&id=a18bbaac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports